import React from 'react';

const TeamSection = () => {
  return (
    <section id="equipe" className="py-32 md:py-40 bg-white">
      <div className="container mx-auto px-6 md:px-12 lg:px-20">
        <div className="max-w-6xl mx-auto">
          
          {/* Section Header */}
          <div className="text-center mb-20 md:mb-24">
            <p 
              className="text-sm uppercase tracking-[0.3em] text-gray-500 mb-6"
              style={{ fontFamily: "var(--font-body)" }}
            >
              L'Équipe
            </p>
            <h2 
              className="text-3xl md:text-4xl lg:text-5xl font-light mb-8 text-gray-900 tracking-[0.12em] uppercase"
              style={{ fontFamily: "var(--font-display)" }}
            >
              Une nouvelle dynamique
            </h2>
            <div className="w-16 h-px bg-gray-400 mx-auto mb-12"></div>
            <p 
              className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto font-light"
              style={{ fontFamily: "var(--font-body)", lineHeight: '2' }}
            >
              La Rotonde s'inscrit dans une nouvelle gouvernance portée par son chef et son maître
              d'hôtel, aujourd'hui à la tête de l'établissement.
            </p>
          </div>

          {/* Chef - Pascal Aguettaz */}
          <div className="mb-24 md:mb-32">
            <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center">
              <div className="order-2 md:order-1">
                <div className="max-w-lg">
                  <h3 
                    className="text-2xl md:text-3xl font-light mb-2 text-gray-900 tracking-[0.1em] uppercase"
                    style={{ fontFamily: "var(--font-display)" }}
                  >
                    Pascal Aguettaz
                  </h3>
                  <p 
                    className="text-base text-gray-500 italic mb-8 tracking-wide"
                    style={{ fontFamily: "var(--font-body)" }}
                  >
                    Chef de Cuisine
                  </p>
                  <div className="w-12 h-px bg-gray-400 mb-8"></div>
                  <div 
                    className="text-lg md:text-xl text-gray-700 font-light space-y-6"
                    style={{ fontFamily: "var(--font-body)", lineHeight: '2' }}
                  >
                    <p>
                      Chef savoyard au parcours international, Pascal Aguettaz met son expérience et
                      son exigence au service d'une cuisine sincère et maîtrisée.
                    </p>
                    <p>
                      Formé aux techniques classiques et enrichi par ses expériences à l'étranger, il
                      accorde une attention particulière à la qualité des produits, à la précision des
                      cuissons et à l'équilibre des saveurs.
                    </p>
                    <p>
                      Sa cuisine s'inspire des saisons et des terroirs, dans le respect du goût et de
                      la tradition, avec une modernité mesurée.
                    </p>
                  </div>
                </div>
              </div>
              <div className="order-1 md:order-2">
                <figure>
                  <img
                    src="https://customer-assets.emergentagent.com/job_divonne-dining/artifacts/hdkc8b3x_Photo%20Pascal.jpg"
                    alt="Pascal Aguettaz - Chef"
                    className="w-full h-auto"
                  />
                  <figcaption 
                    className="mt-4 text-sm text-gray-500 italic tracking-wide"
                    style={{ fontFamily: "var(--font-body)" }}
                  >
                    Pascal Aguettaz — Chef de Cuisine
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>

          {/* Elegant divider */}
          <div className="flex items-center justify-center mb-24 md:mb-32">
            <div className="w-24 h-px bg-gray-300"></div>
            <div className="mx-8 text-gray-300 text-xl">✦</div>
            <div className="w-24 h-px bg-gray-300"></div>
          </div>

          {/* Maître d'Hôtel - François Le Clerc */}
          <div>
            <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center">
              <div>
                <figure>
                  <img
                    src="https://customer-assets.emergentagent.com/job_divonne-dining/artifacts/geuglfwu_grok-image-f0a3855b-db70-40d6-864c-a8ebd0270467.png"
                    alt="François Le Clerc - Directeur & Maître d'Hôtel"
                    className="w-full h-auto"
                  />
                  <figcaption 
                    className="mt-4 text-sm text-gray-500 italic tracking-wide"
                    style={{ fontFamily: "var(--font-body)" }}
                  >
                    François Le Clerc — Directeur & Maître d'Hôtel
                  </figcaption>
                </figure>
              </div>
              <div>
                <div className="max-w-lg lg:ml-auto">
                  <h3 
                    className="text-2xl md:text-3xl font-light mb-2 text-gray-900 tracking-[0.1em] uppercase"
                    style={{ fontFamily: "var(--font-display)" }}
                  >
                    François Le Clerc
                  </h3>
                  <p 
                    className="text-base text-gray-500 italic mb-8 tracking-wide"
                    style={{ fontFamily: "var(--font-body)" }}
                  >
                    Directeur & Maître d'Hôtel
                  </p>
                  <div className="w-12 h-px bg-gray-400 mb-8"></div>
                  <div 
                    className="text-lg md:text-xl text-gray-700 font-light space-y-6"
                    style={{ fontFamily: "var(--font-body)", lineHeight: '2' }}
                  >
                    <p>
                      Directeur de l'établissement, François assure un service attentif, précis et
                      chaleureux.
                    </p>
                    <p>
                      Fort d'une solide expérience dans des établissements exigeants, il supervise
                      l'ensemble des opérations en salle et veille au bon déroulement de chaque
                      service avec rigueur et sens du détail.
                    </p>
                    <p>
                      Son engagement contribue à offrir une expérience harmonieuse et cohérente, où
                      chaque convive se sent pleinement accueilli.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TeamSection;
